import { render, staticRenderFns } from "./input-phone-number.vue?vue&type=template&id=40d0e2be"
import script from "./input-phone-number.vue?vue&type=script&lang=ts"
export * from "./input-phone-number.vue?vue&type=script&lang=ts"
import style0 from "./input-phone-number.vue?vue&type=style&index=0&id=40d0e2be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports